import { Injectable } from '@angular/core';
import { Observable, observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Products } from '../app/shooping.model';


@Injectable({
  providedIn: 'root'
})
export class ShoopingService {

  constructor(private http:HttpClient) { }

  public url = 'https://fakestoreapi.com/products';

  getProducts():Observable<Products[]>{ 
    return this.http.get<Products[]>(this.url);
  }

  findProduct(productId):Observable<Products>{ 
    return this.http.get<Products>(this.url + '/' + productId);
  }

  getCategories():Observable<any> {
    return this.http.get<any>(this.url + '/categories');
  }

  getProductLimit(limit):Observable<any> {
    return this.http.get<any>(this.url + '?limit=' + limit);
  }
  
  sortProducts(type):Observable<any> {
    return this.http.get<any>(this.url +  '?sort=' + type)
  }

  getProductsByCategories(category):Observable<any> {
    return this.http.get<any>(this.url + '/category/' + category );
  }

}
